import React from "react";
import Answer from "./Answer";
const MailReviewStep = ({ classes, allStepsFormData }) => {
  return (
    <div>
      {allStepsFormData
        .sort(step => step.index)
        .map((step, idx) => {
          return (
            <div key={idx}>
              {Object.entries(step.answers).map(([title, value]) => (
                <Answer title={title} value={value} key={title} />
              ))}
            </div>
          );
        })}
    </div>
  );
};
export default MailReviewStep;
